<div class="homeWrapper ">

    <div class="home-leftWrapper">
        <div class="home-activity">
            <div class="activity-header">Recent Activity</div>
            <div class="recentActivityList">
                <div class="comingSoonCover"><p class="comingSoonText">
                    Feature Coming Soon
                </p></div>
            </div></div>
    </div>

    <div class="home-rightWrapper">
        <div class="home-applications">
            <p class="applications-header">Applications</p>
            <div class="applications-list ">
                <app-applicationdiv *ngFor="let item of applications" [appItem]="item" ></app-applicationdiv>
            </div>
        </div>
    </div>
</div>
